/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown>, message: NonNullable<unknown> }} Dashfix_Error_Gateway_StatusInputs */

const en_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gateway error ${i?.status}: ${i?.message}`)
};

const zh_hans1_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`网关错误 ${i?.status}：${i?.message}`)
};

const pt_br2_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro do gateway ${i?.status}: ${i?.message}`)
};

const es_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error del gateway ${i?.status}: ${i?.message}`)
};

const fr_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur de passerelle ${i?.status} : ${i?.message}`)
};

const de_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gateway-Fehler ${i?.status}: ${i?.message}`)
};

const ru_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка шлюза ${i?.status}: ${i?.message}`)
};

const it_dashfix_error_gateway_status = /** @type {(inputs: Dashfix_Error_Gateway_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore del gateway ${i?.status}: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Gateway error {status}: {message}" |
*
* @param {Dashfix_Error_Gateway_StatusInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const dashfix_error_gateway_status = /** @type {((inputs: Dashfix_Error_Gateway_StatusInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashfix_Error_Gateway_StatusInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_dashfix_error_gateway_status(inputs)
	if (locale === "pt-BR") return pt_br2_dashfix_error_gateway_status(inputs)
	if (locale === "es") return es_dashfix_error_gateway_status(inputs)
	if (locale === "fr") return fr_dashfix_error_gateway_status(inputs)
	if (locale === "de") return de_dashfix_error_gateway_status(inputs)
	if (locale === "ru") return ru_dashfix_error_gateway_status(inputs)
	if (locale === "it") return it_dashfix_error_gateway_status(inputs)
	return en_dashfix_error_gateway_status(inputs)
});